/** Floating mini style toolbar shown while an EditableText block is being edited. */
export default function EditableStyleToolbar({
  viewport,
  onViewportChange,
  styleValue,
  onStyleChange,
  align = 'text',
  style,
  toolbarRef,
}) {
  const sv = styleValue || {};
  const mode = sv.backgroundMode || 'none';

  return (
    <div
      ref={toolbarRef}
      className="svcpg-toolbar"
      style={style}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="svcpg-toolbar__group svcpg-toolbar__viewport" role="tablist" aria-label="Viewport">
        <button
          type="button"
          className={`svcpg-toolbar__btn${viewport === 'desktop' ? ' svcpg-toolbar__btn--active' : ''}`}
          onClick={() => onViewportChange('desktop')}
        >
          Desktop
        </button>
        <button
          type="button"
          className={`svcpg-toolbar__btn${viewport === 'mobile' ? ' svcpg-toolbar__btn--active' : ''}`}
          onClick={() => onViewportChange('mobile')}
        >
          Mobile
        </button>
      </div>

      <div className="svcpg-toolbar__group">
        <label className="svcpg-toolbar__label" title="Text color">
          A
          <input
            type="color"
            value={sv.color || '#0b1230'}
            onChange={(e) => onStyleChange({ color: e.target.value })}
          />
        </label>
        {sv.color ? (
          <button type="button" className="svcpg-toolbar__clear" onClick={() => onStyleChange({ color: null })} title="Reset color">
            ×
          </button>
        ) : null}
      </div>

      <div className="svcpg-toolbar__group">
        <select
          className="svcpg-toolbar__select"
          value={mode}
          onChange={(e) => onStyleChange({ backgroundMode: e.target.value })}
          title="Background"
        >
          <option value="none">No background</option>
          <option value="solid">Solid</option>
          <option value="gradient">Gradient</option>
        </select>
        {mode === 'solid' ? (
          <input
            type="color"
            value={sv.backgroundColor || '#ffffff'}
            onChange={(e) => onStyleChange({ backgroundColor: e.target.value })}
            title="Background color"
          />
        ) : null}
        {mode === 'gradient' ? (
          <>
            <input
              type="color"
              value={sv.gradientFrom || '#1f4fe0'}
              onChange={(e) => onStyleChange({ gradientFrom: e.target.value })}
              title="Gradient start"
            />
            <input
              type="color"
              value={sv.gradientTo || '#9db7ff'}
              onChange={(e) => onStyleChange({ gradientTo: e.target.value })}
              title="Gradient end"
            />
            <input
              type="number"
              className="svcpg-toolbar__number"
              value={sv.gradientAngle ?? 135}
              min={0}
              max={360}
              onChange={(e) => onStyleChange({ gradientAngle: Number(e.target.value) })}
              title="Gradient angle"
            />
          </>
        ) : null}
      </div>

      <div className="svcpg-toolbar__group">
        <button
          type="button"
          className="svcpg-toolbar__btn"
          title="Decrease font size"
          onClick={() => onStyleChange({ fontSize: Math.max(8, (sv.fontSize || 16) - 1) })}
        >
          −
        </button>
        <input
          type="number"
          className="svcpg-toolbar__number"
          value={sv.fontSize || ''}
          placeholder="px"
          onChange={(e) => onStyleChange({ fontSize: e.target.value ? Number(e.target.value) : null })}
        />
        <button
          type="button"
          className="svcpg-toolbar__btn"
          title="Increase font size"
          onClick={() => onStyleChange({ fontSize: (sv.fontSize || 16) + 1 })}
        >
          +
        </button>
      </div>

      <div className="svcpg-toolbar__group">
        <button
          type="button"
          className={`svcpg-toolbar__btn${sv.fontWeight === 'bold' || sv.fontWeight === '700' ? ' svcpg-toolbar__btn--active' : ''}`}
          title="Bold"
          onClick={() => onStyleChange({ fontWeight: sv.fontWeight === 'bold' || sv.fontWeight === '700' ? null : 'bold' })}
        >
          <strong>B</strong>
        </button>
      </div>

      {align === 'text' ? (
        <div className="svcpg-toolbar__group">
          {['left', 'center', 'right'].map((a) => (
            <button
              key={a}
              type="button"
              className={`svcpg-toolbar__btn${sv.textAlign === a ? ' svcpg-toolbar__btn--active' : ''}`}
              title={`Align ${a}`}
              onClick={() => onStyleChange({ textAlign: sv.textAlign === a ? null : a })}
            >
              {a === 'left' ? '⟸' : a === 'right' ? '⟹' : '≡'}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
